export const CODE_BLOCK_REGEX = /(```\w+?\n[\s\S]+?\n```)/gm;
export const PARSE_CODE_BLOCK_REGEX = /```(\w+)\n([\s\S]+?)\n```/m;